import React from "react";

const Admindashboard=()=>{

   return (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",   
    textAlign: "center"
  }}>
    <h2>Coming Soon</h2>
  </div>
);

}
export default Admindashboard;